import { createGlobalStyle } from "styled-components";
import { rootFixedColor, rootFixedSize } from "./theme";
import PretendardRegular from './fonts/Pretendard-Regular.woff2';
import PretendardSemiBold from './fonts/Pretendard-SemiBold.woff2';
import PretendardExtraBold from './fonts/Pretendard-ExtraBold.woff2';

const GlobalStyles = createGlobalStyle`
    @font-face {
        font-family: "PretendardRegular";
        src: url(${PretendardRegular}) format('woff2');
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "PretendardSemiBold";
        src: url(${PretendardSemiBold}) format('woff2');
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "PretendardExtraBold";
        src: url(${PretendardExtraBold}) format('woff2');
        font-style: normal;
        font-display: swap;
    }
    // 전역변수 설정
    :root {
        // 기본값
        --vh: 100%;
        --bg-color-header: #f5f5f5;
        --font-pretendard-medium: "PretendardRegular";
        --font-pretendard-bold: "PretendardSemiBold";
        --font-pretendard-extra-bold: "PretendardExtraBold";
    }
    body {
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        margin: 0;
        padding: 0;
        color: ${(props) => props.theme.rootTextColor};
        background-color: ${(props) => props.theme.rootBgColor};
        margin: auto;
        overflow-y: auto;
        min-width: 768px;
        font-family: var(--font-pretendard-medium);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: ${rootFixedSize.rootFontSize};
        word-break: keep-all;
    }
    #root {
        height: 100vh;
    }
    *, *::after, *::before {
        box-sizing: border-box;
        font-family: var(--font-pretendard-medium);
    }
    .side-menu-bar.show-all ~ footer {
        min-width: calc(1024px + 13.125rem);
        padding-left: 13.125rem;
    }
    // -----
    input, select {
        font-family: var(--font-pretendard-medium);
        font-size: 0.875rem;
        height: 2.25rem;
    }
    p {
        margin: 0;
    }
    ul,
    li {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    a {
        text-decoration: none;
        cursor: pointer;
        color: ${(props) => props.theme.rootTextColor};
        &:focus, &:focus-visible {
            border: none;
            outline: none;
        }
        &:active, &:hover, &:visited  {
            color: ${(props) => props.theme.rootTextColor};
        }
    }
    // button
    button {
        cursor: pointer;
        background: none;
        border: none;
    }
    .default-btn {
        padding: 0.5rem;
        border-radius: 0.5rem;
        &.edit-btn {
            background-color: ${rootFixedColor.btnEditBgColor};
            color: ${rootFixedColor.rootTextColor};
            &:not(:disabled):hover {
                background-color: ${rootFixedColor.btnEditBgHoverColor};
            }
        }
        &.delete-btn {
            background-color: ${rootFixedColor.btnDeleteBgColor};
            color: ${rootFixedColor.rootTextColor};
            &:not(:disabled):hover {
                background-color: ${rootFixedColor.btnDeleteBgHoverColor};
            }
        }
        &.list-btn {
            background-color: ${rootFixedColor.btnListBgColor};
            color: ${rootFixedColor.rootTextColorB};
            &:not(:disabled):hover {
                background-color: ${rootFixedColor.btnListBgHoverColor};
            }
        }
        &:disabled {
            background-color: ${rootFixedColor.statusOffColor};
            &:hover {
                cursor: context-menu;
            }
        }
    }
    @media screen and (max-width: 1080px){
        body {
            font-size: 13px;
        }
    }
    /* 스크롤바 CSS */
    ::-webkit-scrollbar {
        width: 10px;  
        height: 10px;  
    }
    ::-webkit-scrollbar-thumb {
        background: ${prop => prop.theme.scrollbarThumbColor}; /* 스크롤바 색상 */
        border-radius: 10px; /* 스크롤바 둥근 테두리 */
    }
    ::-webkit-scrollbar-track {
        background: ${prop => prop.theme.scrollbarTrackColor};  /*스크롤바 뒷 배경 색상*/
        border-radius: 10px; /* 스크롤바 둥근 테두리 */
    }
`;

export default GlobalStyles;